import transitionPath from 'router5-transition-path'
import { findRoutes }  from '../utils'

import {
  MiddlewareFactory,
} from '../../../types/frontend/router'

import {
  AppRoute,
} from '../../../types/frontend/router'

import {
  RootState,
} from '../../../types/frontend/store_generic'

import {
  isDevelopment,
} from '../../../utils/settings'

/*

  if the active route has a redirect property - redirect there

*/
function RedirectMiddlewareFactory<RootStateType extends RootState = RootState>() {
  const redirectRoute: MiddlewareFactory<RootStateType> = (routes) => (router, dependencies) => (toState, fromState, done) => {
    const { toActivate } = transitionPath(toState, fromState)
    const { store } = dependencies

    const activeRoutes = findRoutes(routes as AppRoute<RootState>[], toActivate)
    const activeRoute = activeRoutes[activeRoutes.length-1]

    if(!activeRoute) return done()

    const redirectHandler = activeRoute.redirect
    if(!redirectHandler) return done()

    const runRedirectHandler = async () => {
      const redirectResult = await redirectHandler(store, toState)

      if(isDevelopment()) {
        console.log(`redirectResult`)
        console.dir(redirectResult)
      }
  
      if(!redirectResult) return done()
  
      done({
        redirect: {
          name: redirectResult.name,
          params: Object.assign({}, toState.params, redirectResult.params),
        },
      })
    }

    runRedirectHandler() 
  }

  return redirectRoute
}

export default RedirectMiddlewareFactory